import type { CSSProperties, ReactElement } from 'react';
import { Select } from 'antd';
import type { Locale } from '@govard/i18n-core';
import { useTranslation } from '@govard/i18n-core/react';
import { getBrowserStorage, writeStoredLocale } from '../../i18n/locale.js';

interface LanguageSwitcherProps {
  className?: string;
  style?: CSSProperties;
}

export function LanguageSwitcher({ className, style }: LanguageSwitcherProps): ReactElement {
  const { t, locale, setLocale } = useTranslation();

  return (
    <Select<Locale>
      {...(className ? { className } : {})}
      size="small"
      value={locale}
      aria-label={t('crm.language.label')}
      data-testid="crm-language-switcher"
      onChange={(nextLocale) => {
        setLocale(nextLocale);
        writeStoredLocale(getBrowserStorage(), nextLocale);
      }}
      options={[
        { value: 'ru', label: t('crm.language.ru') },
        { value: 'en', label: t('crm.language.en') },
      ]}
      style={{ width: 72, ...style }}
    />
  );
}
